import UsersTableHelper from './users-table-helper';
import usersFuncHelper from './users-functions-helper';


const UsersHelpers = {
    TableMain: UsersTableHelper,
    Functions: usersFuncHelper,
}

export default UsersHelpers;